import React from 'react';

const ReleaseNotes = () => {
  return (
    <div className="flex items-center justify-center bg-gray-100 p-2">
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-3xl w-full">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Release Notes</h1>
        <p className="text-gray-600 mb-6">
          Here are the latest updates and improvements to our application. Stay tuned for more!
        </p>
        
        {/* Release Notes Section */}
        {/* <div className="space-y-4"> */}  
          {/* <div className="border-t pt-4">
            <h2 className="text-xl font-semibold text-gray-800">Version 2.0.1</h2>
            <p className="text-gray-600">Released on 2024-11-01</p>
            <ul className="list-disc list-inside mt-2 text-gray-700 space-y-2">
              <li>Added new checklist feature with pass/fail options for inspections.</li>
              <li>Enhanced UI for a smoother user experience.</li>
              <li>Bug fixes and performance improvements.</li>
            </ul>
          </div> */}  

          {/* <div className="border-t pt-4">
            <h2 className="text-xl font-semibold text-gray-800">Version 2.0.0</h2>
            <p className="text-gray-600">Released on 2024-10-15</p>
            <ul className="list-disc list-inside mt-2 text-gray-700 space-y-2">
              <li>Introduced new inspection form layout with file upload support.</li>
              <li>Enhanced data fetching capabilities from uploaded metadata.</li>
              <li>Minor bug fixes.</li>
            </ul>
          </div> */}
        {/* </div> */}

        {/* Download Button */}
        <div className="mt-6 flex justify-end">
          <a
            href="Release Note Re-DOMS Phase 1.pdf"
            download="Release Note Re-DOMS Phase 1.pdf"
            className="inline-flex items-center px-4 py-2 bg-[#424752] hover:bg-gray-500 text-white font-medium rounded-md shadow"
          >
            Download PDF
            <svg className="ml-2 w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;

